import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Navigator from "../Navigation";
import { currency, dateFormat, getStoreType, timeFormat } from "../../../../dynamicController";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

const PackDetails = ({ user, token }) => {
    const history = useHistory();
    const location = useLocation();
    const [list, setList] = useState([]);

    const { t } = useTranslation();

    useEffect(() => {
        if (!user) {
            history.push('/')
        } else if (!location.state) {
            history.push('/')
        } else if (location.state.transaction) {
            const { transaction_items } = location.state.transaction
            let itemList = []
            for (let i = 0; i < transaction_items.length; i++) {
                let pack = itemList.filter(item => item.sequence === transaction_items[i].sequenceId)[0]
                if (pack) {
                    if (transaction_items[i].name === "Wash") {
                        pack.wash = true
                        pack.washCapacity = transaction_items[i].capacity
                        pack.washMode = transaction_items[i].mode
                        pack.washPrice = transaction_items[i].price
                        pack.washStatus = transaction_items[i].status
                    } else if (transaction_items[i].name === "Dry") {
                        pack.dry = true
                        pack.dryCapacity = transaction_items[i].capacity
                        pack.dryDuration = transaction_items[i].machine_duration
                        pack.dryPrice = transaction_items[i].price
                        pack.dryStatus = transaction_items[i].status
                    } else if (transaction_items[i].name === "Fold") {
                        pack.fold = true
                        pack.foldPrice = transaction_items[i].price
                        pack.foldStatus = transaction_items[i].status
                    } else if (transaction_items[i].name === "Ironing") {
                        pack.ironing = true
                        pack.ironingPrice = transaction_items[i].price
                        pack.ironingStatus = transaction_items[i].status
                    } else if (transaction_items[i].name === "Accessory") {
                        pack.accessory = true
                        if (pack.accessoryItem) {
                            pack.accessoryItem.push(transaction_items[i])
                        } else {
                            pack.accessoryItem = [transaction_items[i]]
                        }
                    } else if (transaction_items[i].name === "Charge") {
                        pack.charge = true
                        pack.chargePrice = transaction_items[i].price
                        pack.description = transaction_items[i].mode
                    }
                } else {
                    let tempObject = {
                        sequence: transaction_items[i].sequenceId,
                        size: transaction_items[i].size,
                        collect_time: transaction_items[i].sequence.collect_time
                    }
                    if (transaction_items[i].name === "Wash") {
                        tempObject.wash = true
                        tempObject.washCapacity = transaction_items[i].capacity
                        tempObject.washMode = transaction_items[i].mode
                        tempObject.washPrice = transaction_items[i].price
                        tempObject.washStatus = transaction_items[i].status
                    } else if (transaction_items[i].name === "Dry") {
                        tempObject.dry = true
                        tempObject.dryCapacity = transaction_items[i].capacity
                        tempObject.dryDuration = transaction_items[i].machine_duration
                        tempObject.dryPrice = transaction_items[i].price
                        tempObject.dryStatus = transaction_items[i].status
                    } else if (transaction_items[i].name === "Fold") {
                        tempObject.fold = true
                        tempObject.foldPrice = transaction_items[i].price
                        tempObject.foldStatus = transaction_items[i].status
                    } else if (transaction_items[i].name === "Ironing") {
                        tempObject.ironing = true
                        tempObject.ironingPrice = transaction_items[i].price
                        tempObject.ironingStatus = transaction_items[i].status
                    } else if (transaction_items[i].name === "Accessory") {
                        tempObject.accessory = true
                        tempObject.accessoryItem = [transaction_items[i]]
                    } else if (transaction_items[i].name === "Charge") {
                        tempObject.charge = true
                        tempObject.chargePrice = transaction_items[i].price
                        tempObject.description = transaction_items[i].mode
                    }
                    itemList.push(tempObject)
                }
            }
            setList(itemList)
        }
    }, [])

    const collect = (id) => {
        mySwal.fire({
            title: t("Confirmation"),
            text: t("Are you sure you have collected your laundry?"),
            icon: "question",
            showCancelButton: true,
            cancelButtonText: t("No"),
            confirmButtonText: t("Yes"),
            customClass: {
                confirmButton: 'collect-yes',
                cancelButton: 'collect-no'
            },
        })
            .then(click => {
                if (click.isConfirmed && click.value) {
                    axios
                        .post("/api/user/dng/collected", { id, role: "user", token })
                        .then(res => {
                            setList(prevList => prevList.map(pack => pack.sequence === id ? { ...pack, collect_time: new Date() } : pack))
                        })
                        .catch(err => {
                            mySwal.fire(t("Error"), t(err.response.data.error), "error")
                        });
                }
            })
    }

    return (
        <div id="trans-details-page">
            <div id="user-header">
                <h5>
                    <strong onClick={() => history.goBack()}>
                        <i className="bi bi-chevron-left me-3"></i> {t("Back")}
                    </strong>
                </h5>
            </div>
            <div className="pb-5">
                {
                    list.map((pack, index) => {
                        return (
                            <div key={index} className="payment-section">
                                <div className="d-flex justify-content-between">
                                    <p><b>{t("Pack Number")}</b></p>
                                    <p><b>{pack.sequence}</b></p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p>{t("Size")}</p>
                                    <p>{pack.size}</p>
                                </div>
                                {
                                    pack.collect_time ? (
                                        <div className="d-flex justify-content-between">
                                            <p>{t("Collect Time")}</p>
                                            <p>{dateFormat(pack.collect_time)} {timeFormat(pack.collect_time, true)}</p>
                                        </div>
                                    ) : null
                                }
                                {
                                    pack.wash ? (
                                        <div>
                                            <div style={{ border: "1px solid #f2f2f2", margin: "5px -20px" }}></div>
                                            <p><b>{t("Wash")}</b></p>
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Mode")}</p>
                                                <p>{t(pack.washMode)}</p>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Capacity")}</p>
                                                <p>{pack.washCapacity}</p>
                                            </div>
                                            {
                                                user && user.dng_pricing_show ? (
                                                    <div className="d-flex justify-content-between">
                                                        <p>{t("Price")}</p>
                                                        <p className="blue-t"><b>{STORETYPE === "cleanpro" && user && user.tokenSetting ? `${pack.washPrice} ${t("credit")}` : `${currency(user.country)} ${pack.washPrice}`}</b></p>
                                                    </div>
                                                ) : null
                                            }
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Status")}</p>
                                                <p style={{ color: pack.washStatus === "Completed" ? "green" : "#FF3C00" }}>{t(pack.washStatus)}</p>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                {
                                    pack.dry ? (
                                        <div>
                                            <div style={{ border: "1px solid #f2f2f2", margin: "5px -20px" }}></div>
                                            <p><b>{t("Dry")}</b></p>
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Duration")}</p>
                                                <p>{pack.dryDuration} {t("min")}</p>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Capacity")}</p>
                                                <p>{pack.dryCapacity}</p>
                                            </div>
                                            {
                                                user && user.dng_pricing_show ? (
                                                    <div className="d-flex justify-content-between">
                                                        <p>{t("Price")}</p>
                                                        <p className="blue-t"><b>{STORETYPE === "cleanpro" && user && user.tokenSetting ? `${pack.dryPrice} ${t("credit")}` : `${currency(user.country)} ${pack.dryPrice}`}</b></p>
                                                    </div>
                                                ) : null
                                            }
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Status")}</p>
                                                <p style={{ color: pack.dryStatus === "Completed" ? "green" : "#FF3C00" }}>{t(pack.dryStatus)}</p>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                {
                                    pack.ironing ? (
                                        <div>
                                            <div style={{ border: "1px solid #f2f2f2", margin: "5px -20px" }}></div>
                                            <p><b>{t("Ironing")}</b></p>
                                            {
                                                user && user.dng_pricing_show ? (
                                                    <div className="d-flex justify-content-between">
                                                        <p>{t("Price")}</p>
                                                        <p className="blue-t"><b>{STORETYPE === "cleanpro" && user && user.tokenSetting ? `${pack.ironingPrice} ${t("credit")}` : `${currency(user.country)} ${pack.ironingPrice}`}</b></p>
                                                    </div>
                                                ) : null
                                            }
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Status")}</p>
                                                <p style={{ color: pack.ironingStatus === "Completed" ? "green" : "#FF3C00" }}>{t(pack.ironingStatus)}</p>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                {
                                    pack.fold ? (
                                        <div>
                                            <div style={{ border: "1px solid #f2f2f2", margin: "5px -20px" }}></div>
                                            <p><b>{t("Fold")}</b></p>
                                            {
                                                user && user.dng_pricing_show ? (
                                                    <div className="d-flex justify-content-between">
                                                        <p>{t("Price")}</p>
                                                        <p className="blue-t"><b>{STORETYPE === "cleanpro" && user && user.tokenSetting ? `${pack.foldPrice} ${t("credit")}` : `${currency(user.country)} ${pack.foldPrice}`}</b></p>
                                                    </div>
                                                ) : null
                                            }
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Status")}</p>
                                                <p style={{ color: pack.foldStatus === "Completed" ? "green" : "#FF3C00" }}>{t(pack.foldStatus)}</p>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                {
                                    pack.accessory ? (
                                        <div>
                                            <div style={{ border: "1px solid #f2f2f2", margin: "5px -20px" }}></div>
                                            <p><b>{t("Accessory")}</b></p>
                                            {
                                                pack.accessoryItem.map((item, i) => {
                                                    return (
                                                        <div key={i} className="d-flex justify-content-between">
                                                            <p>{item.mode} x {item.quantity}</p>
                                                            <p><b>{STORETYPE === "cleanpro" && user && user.tokenSetting ? `${item.price} ${t("credit")}` : `${currency(user.country)} ${item.price}`}</b></p>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Price")}</p>
                                                <p className="blue-t"><b>{STORETYPE === "cleanpro" && user && user.tokenSetting ? `${pack.accessoryItem.map(item => parseFloat(item.price) * parseFloat(item.quantity)).reduce((a, b) => a + b, 0)} ${t("credit")}` : `${currency(user.country)} ${pack.accessoryItem.map(item => parseFloat(item.price) * parseFloat(item.quantity)).reduce((a, b) => a + b, 0)}`}</b></p>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                {
                                    pack.charge ? (
                                        <div>
                                            <div style={{ border: "1px solid #f2f2f2", margin: "5px -20px" }}></div>
                                            <p><b>{t("Charge")}</b></p>
                                            <div className="d-flex justify-content-between">
                                                <p>{t("Description")}</p>
                                                <p>{t(pack.description)}</p>
                                            </div>
                                            {
                                                user && user.dng_pricing_show ? (
                                                    <div className="d-flex justify-content-between">
                                                        <p>{t("Price")}</p>
                                                        <p className="blue-t"><b>{STORETYPE === "cleanpro" && user && user.tokenSetting ? `${pack.chargePrice} ${t("credit")}` : `${currency(user.country)} ${pack.chargePrice}`}</b></p>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    ) : null
                                }
                                {
                                    !pack.collect_time && location.state.transaction.transaction_items.filter(item => item.status === "Pending" && item.sequenceId === pack.sequence).length <= 0 && location.state.transaction.transaction_items.filter(item => item.name === "Charge").length <= 0 ? (
                                        <div>
                                            <button id="collect-btn" className="big-button form-control btn mb-3" onClick={() => collect(pack.sequence)}>{t("Collected")}</button>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                    })
                }
            </div>
            <Navigator />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        token: state.user.token,
    };
};

export default connect(mapStateToProps, null)(PackDetails);